import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitFormData, applyAutoSlip } from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global";
import SharedForm from "../../../../../widgets/SharedForm";
import { fnSave } from "@shared/api/restApi";
import SearchPanel from "../../../../../widgets/SearchPanel";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "src/widgets/CommonDialog";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { dateToString } from "@shared/utils/DateUtils";
import { SnButton } from "@shared/components/SnButton";
import { ElevatorSharp } from "@mui/icons-material";
interface Props {
  Menuprops: menuInfo;
}

const SN_MTL_PTY_REG_003 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();
  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    sheet1: React.createRef(),
  });
  const sharedFormRef1 = useRef<any>();
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [sharedForm, setSharedForm] = useState<any[]>([]);
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [btnText, setBtnText] = useState<any>();
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setSharedForm(rtn.form.freeform1);
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  const onSearch = async () => {
    try {
      const modifiedRows = gridRefs.current["grid1"].current.getChange();
      if (modifiedRows.modifiedRowcount > 0) {
        const confirm = await showDialog(
          "confirm",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm) {
          const isSaved = await onSave();
          if (!isSaved) return;
        }
      }

      const params = {
        id: "sn_mtl_pty_reg_003_01",
        params: searchRef.current.getFormdata(),
      };

      setFocusedRowData(null);
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1],
      });
    } catch (error: any) {}
  };

  const onInsert = () => {
    const searchFormData = searchRef.current.getFormdata();
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (
      // focusedNodeH.data?.yn_repair === "Y" &&
      focusedNodeH.data?.st_property !== "STOCK"
    ) {
      return;
    }

    const newRow = {
      cd_firm: userInfo.cd_firm,
      dt_req: dateToString(new Date()),
      st_repair: "",
      cd_property: focusedNodeH.data?.cd_property,
      yn_repair: "N",
    };
    const addedNode = gridRefs.current["grid2"].current?.addRow(newRow);
    if (addedNode && addedNode.data) {
      setFocusedRowData(addedNode.data);
    }
  };

  const onDelete = async () => {
    if (gridRefs.current["grid2"].current.getDisplayedRowCount() < 1) return;

    const focusedRowNode = gridRefs.current["grid2"]?.current.focusedRowNode();
    let rowIndex: any = 0;
    if (focusedRowNode) rowIndex = focusedRowNode.rowIndex;

    gridRefs.current["grid2"].current?.deleteSelectedRows();
    if (rowIndex === 0) {
      setFocusedRowData(null);
    } else {
      const newRowIndex = rowIndex === 0 ? 0 : rowIndex - 1;
      gridRefs.current["grid2"].current?.selectAndFocusRow(newRowIndex);
    }
  };

  const onSave = async () => {
    let repairChanges;
    let propertyChanges;
    try {
      gridRefs.current["grid2"].current.stopEditing();

      const requiredValuesCheck =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheck) return false;

      propertyChanges = gridRefs.current["grid1"].current.getChange();
      repairChanges = gridRefs.current["grid2"].current.getChange();
      if (repairChanges.modifiedRowcount == 0) {
        await showDialog("alter", "저장할 내용이 없습니다.");
        return false;
      }

      const focusedRowNodeH =
        gridRefs.current["grid2"].current.focusedRowNode();
      const noSlip = await applyAutoSlip({
        cd_column: "no_repair",
        cd_module: Menuprops.cd_module,
        no_line: 36,
        dt: dateToString(new Date()),
        girdrefs: [gridRefs.current["grid2"]],
        inserts: [repairChanges],
        cd_menu: Menuprops.cd_menu,
      });

      const saveData = {
        property: propertyChanges,
        repair: repairChanges,
      };
      const ok = await fnSave("SN_MTL_PTY_REG_003_SAVE_01", saveData);
      if (!ok) return false;

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      // sharedFormRef1.current["freeform1"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      // sharedFormRef1.current["freeform1"].current.resetUpdate(true);
      return false;
    }
  };

  const getButtonText = (row: any) => {
    //if (!row || !row.st_repair) return "접수";
    if (row.st_repair === "") return "접수";
    if (row.st_repair === "F") return "수리중";
    if (row.st_repair === "R") return "수리완료";
    return null; // C면 버튼 숨김
  };

  const onRepairProcess = async (id: string) => {
    const grid2 = gridRefs.current["grid2"].current;
    const grid1 = gridRefs.current["grid1"].current;

    const node = grid2.focusedRowNode();
    if (!node) return;

    const data = node.data;
    const headerNode = grid1.focusedRowNode();

    if (!headerNode) return;

    const header = headerNode.data;
    if (id !== "cancel") {
      if (!data.st_repair) {
        if (header?.st_property !== "STOCK") {
          await showDialog("alert", "STOCK 상태만 접수 가능");
          return;
        }

        node.setDataValue("st_repair", "F");
        headerNode.setDataValue("st_property", "REPAIR");
        headerNode.setDataValue("cd_location", "REPAIR");

        const ok = await onSave();
        if (!ok) return;
        return;
      }

      if (data.st_repair === "F") {
        if (!data.dt_start) {
          await showDialog("alert", "수리시작일 입력하세요");
          return;
        }

        node.setDataValue("st_repair", "R");

        const ok = await onSave();
        if (!ok) return;
        return;
      }

      if (data.st_repair === "R") {
        if (!data.dt_end) {
          await showDialog("alert", "수리완료일 입력하세요");
          return;
        }

        node.setDataValue("st_repair", "C");

        headerNode.setDataValue("st_property", "STOCK");
        headerNode.setDataValue("cd_location", "STOCK");

        const ok = await onSave();
        if (!ok) return;
        return;
      }
    } else {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const focusedNodeL = gridRefs.current["grid2"].current.focusedRowNode();

      gridRefs.current["grid2"].current.setValueImmediately(
        focusedNodeL,
        "st_repair",
        "X"
      );
      gridRefs.current["grid1"].current.setValueImmediately(
        focusedNodeH,
        "st_property",
        "STOCK"
      );

      const ok = await onSave();
      if (!ok) return;
      return;
      //}
    }
  };

  const onFocusedRowChanged = useCallback(
    (focusedRowData: any | null) => {
      if (!focusedRowData) {
        setFocusedRowData(null);
      } else {
        setFocusedRowData(focusedRowData);
      }
      if (
        focusedRowData?.st_repair === "R" ||
        focusedRowData?.st_repair === "F"
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
      setBtnText(getButtonText(focusedRowData));
    },
    [focusedRowData]
  );

  const onValueChaged = async (data: any, param: string, formData: any) => {
    switch (param) {
      default:
        return {};
    }
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onFocusedRowChanged,
          // onBeforeAddRow: onBeforeAddRow2,
        },
      },
      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="w-full flex h-full min-h-0 space-x-1.5">
        <SnResizeBar direction={"width"} id="panel1" orgSize="33.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              rowSelection: "single",
              title: "비품정보",
              isEditable: false,
            }}
            events={grids.grid1.events}
            filter={{
              refs: [gridRefs.current["grid2"]],
              columns: ["cd_property"],
            }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"width"} id="panel2" orgSize="66.5%">
          <SnResizeBar direction={"height"} id="panel3" orgSize="50.5%">
            <SharedForm
              ref={sharedFormRef1}
              data={focusedRowData}
              controls={sharedForm}
              gridref={gridRefs.current["grid2"]}
              onValueChaged={onValueChaged}
              title="상세정보"
              header={
                <div>
                  {btnText && (
                    <SnButton
                      text={btnText}
                      onClick={() => {
                        onRepairProcess("");
                      }}
                    />
                  )}
                  {isVisible && (
                    <SnButton
                      text={"취소"}
                      onClick={() => {
                        onRepairProcess("cancel");
                      }}
                    />
                  )}
                </div>
              }
            />

            <SnGrid
              ref={gridRefs.current["grid2"]}
              columnConfig={grids.grid2.columns}
              rowData={grids.grid2.dataSource}
              etcProps={{ rowSelection: "single" }}
              events={grids.grid2.events}
            />
          </SnResizeBar>
        </SnResizeBar>
      </div>
    </div>
  );
});

export default SN_MTL_PTY_REG_003;
